import { render, staticRenderFns } from "./botaoTelaInicial.vue?vue&type=template&id=5f5ac99d&scoped=true"
import script from "./botaoTelaInicial.vue?vue&type=script&lang=js"
export * from "./botaoTelaInicial.vue?vue&type=script&lang=js"
import style0 from "./botaoTelaInicial.vue?vue&type=style&index=0&id=5f5ac99d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5ac99d",
  null
  
)

export default component.exports